import TooltipModule from "./tooltipModule";

export default TooltipModule;